import { msg } from "@lit/localize";

/**
 * Die Auswahl-Zeilen der Startseite.
 *
 * Jeder Block muss sagen können, wonach ausgewählt wurde — sonst wirkt eine
 * Fünferliste wie eine Wertung. Die Sätze stehen HIER und nicht in der
 * Pipeline: Sie sind Anzeige-Text, und Anzeige-Text durch die Daten zu
 * schleifen hieße, ihn in jedem Export mitzuschreiben und in jeder Sprache
 * doppelt zu pflegen.
 *
 * Der Preis ist, dass sie zur Export-Regel passen müssen. Deshalb steht die
 * Regel als Kommentar daneben, mit ihrer Stelle in der Pipeline
 * (`packages/export/src/uebersichten.ts`). Wer dort die Auswahl ändert, ändert
 * hier den Satz.
 *
 * KEINE ANZAHLEN IN DEN SÄTZEN. „Die fünf zuletzt entschiedenen" behauptet
 * etwas, das die Liste darunter ohnehin zeigt — und das falsch wird, sobald
 * die Pipeline ihre Seitengröße ändert oder ein Bezirk nur drei Beschlüsse
 * hat. Was nicht behauptet wird, kann nicht driften. Wo eine Zahl wirklich
 * etwas sagt, weil sie auf Weggelassenes hinweist (die Ausschuss-Liste), wird
 * sie aus den Daten gerechnet, nicht geschrieben.
 */

/** `baueGebietsverzeichnis` — Bezirke nach amtlicher Nummer, Stadtteile alphabetisch. */
export const AUSWAHL_GEBIETE = () =>
  msg("alle Stadtbezirke nach amtlicher Nummer, Stadtteile alphabetisch", {
    id: "app.start.auswahl.gebiete",
  });

/**
 * `wahlzusammenfassungen` (Pipeline) liefert die stimmstärksten Kräfte; die
 * Kurzfassung (`wahlen/wahl-kurzfassung.ts`) zeigt DREI davon, alle übrigen
 * als Sammelzeile. Derselbe Satz auf Startseite und Gebietsseiten — es ist
 * dieselbe Auswahl.
 */
export const AUSWAHL_WAHL = () =>
  msg("die stimmstärksten Wahlvorschläge, alle weiteren als Sammelzeile", {
    id: "app.start.auswahl.wahl",
  });

/**
 * `baueAufmacher` — nach `letzteStation.datum` absteigend, die ersten fünf.
 *
 * OHNE Ortsangabe: Den nennt die Blocküberschrift („Das wird gerade im
 * Stadtbezirk Ehrenfeld entschieden"). Stünde er hier auch, stünde derselbe
 * Halbsatz zweimal direkt untereinander. Überschrift sagt WO, Auswahl-Zeile
 * sagt WONACH.
 */
export const AUSWAHL_BESCHLUESSE = () =>
  msg("die zuletzt entschiedenen Drucksachen", { id: "app.start.auswahl.beschluesse" });

/** `baueAufmacher` — nach `date` absteigend, die ersten fünf. Ort s. o. */
export const AUSWAHL_DRUCKSACHEN = () =>
  msg("die zuletzt eingebrachten Drucksachen", { id: "app.start.auswahl.drucksachen" });

/**
 * `baueAufmacher` — kommende Sitzungen nach Beginn aufsteigend, die ersten
 * fünf. Bei einem Gebiet sind die stadtweiten Sitzungen dabei: Von 87
 * kommenden Sitzungen sind 61 Rat und Ausschüsse — ohne sie sähe ein
 * Ehrenfelder drei Termine, während der Rat unerwähnt bliebe.
 */
export const AUSWAHL_TERMINE = () =>
  msg("die nächsten Sitzungen, stadtweite eingeschlossen", {
    id: "app.start.auswahl.termine",
  });

/**
 * Beschreibt, was der Block WIRKLICH zeigt: drei Kacheln aus amtlichen
 * Angaben — Sitzplan für den Rat, Übersicht der Stadt für Gremien und
 * Bezirksvertretungen. Aus dem Ratsinformationssystem kommen nur noch die
 * Verknüpfungen.
 *
 * Der Satz ist zweimal nachgezogen worden, weil sich der Block zweimal
 * geändert hat — genau dafür steht er hier und nicht in der Pipeline.
 */
export const AUSWAHL_GREMIEN = () =>
  msg("die Gremien der Stadt nach ihren amtlichen Übersichten", {
    id: "app.start.auswahl.gremien",
  });

/**
 * Dasselbe Verzeichnis, aber die Bezirksvertretungen auf das gemerkte Gebiet
 * eingeengt. Rat und Ausschüsse bleiben vollständig — sie entscheiden über die
 * ganze Stadt.
 */
export const AUSWAHL_GREMIEN_GEBIET = () =>
  msg("Rat und Ausschüsse stadtweit, alphabetisch — die Bezirksvertretung des gemerkten Gebiets", {
    id: "app.start.auswahl.gremien.gebiet",
  });

/** `baueDatenstand` — jüngster ABGESCHLOSSENER Lauf je Quelle. */
export const AUSWAHL_QUELLEN = () =>
  msg("der jüngste abgeschlossene Lauf je Quelle", { id: "app.start.auswahl.quellen" });
